import React, { useContext, useEffect, useState } from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
} from '@sitecore-jss/sitecore-jss-react';
import { AppBar, Toolbar } from '@mui/material';
import { dictionaryService } from '../../dataFetcher/dictionaryService';
import { APIWebstoreContext } from '../../context/globalContext';
import './index.scss';

import { isTokenExists } from '../../utils/authHelper';
import { getAPICall } from '../../dataFetcher/axiosMethodCalls';
import { LOB_LIST } from '../../context/reducer';

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

export default function Header(props: Props) {
  const { state, dispatch } = useContext(APIWebstoreContext);

  function getCartQuantity() {
    getAPICall(`${process.env.REACT_APP_CART_URL}/cartOrder/quantity`).then(function (
      response: any
    ) {
      if (response && response.status === 200) {
        const lobCounts = LOB_LIST.reduce((acc, lob) => {
          const lobData = response.data.totals.find((data: any) => data.lob === lob);
          acc[lob] = lobData?.quantity || 0;
          return acc;
        }, {} as Record<string, number>);

        if (dispatch) {
          dispatch({
            type: 'CART_UPDATE',
            payload: {
              cartCounts: {
                totalCount: response.data.totalQuantity,
                lobCounts,
              },
            },
          });
        }
      }
    });
  }

  useEffect(() => {
    if (isTokenExists()) {
      getCartQuantity();
    }
  }, [state?.toggleCartQuantityLoad]);

  function fetchDictionaryData() {
    if (state?.sitecoreDictionaryData && Object.keys(state?.sitecoreDictionaryData).length === 0) {
      const language = 'en';
      dictionaryService.fetchDictionaryData(language).then((data) => {
        if (dispatch) {
          dispatch({
            type: 'SITECORE_DICTIONARY',
            payload: { sitecoreDictionaryData: data },
          });
        }
      });
    }
  }

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  return (
    <div className="unified-header-main">
      <nav aria-label="PrimaryNavigation">
        <div className="grow">
          <div className="navHeight">
            <AppBar className="unifiedheader unifiedPage">
              <Toolbar disableGutters className="toolbar">
                <div className="logoImage">
                  <Placeholder name="logo_container" rendering={props.rendering} />
                </div>
                <div className="sectionDesktop">
                  {/* Desktop Navigation Here*/}
                  <div className="desktopNavItems">
                    <Placeholder
                      name="desktop_main_navigation"
                      rendering={props.rendering}
                      isCustom={true}
                    />
                  </div>
                  <div className="LoginItem">
                    <Placeholder name="login_container" rendering={props.rendering} />
                  </div>
                  <div className="CartItem">
                    <Placeholder name="cart_container" rendering={props.rendering} />
                  </div>
                  {/* / END Desktop Navigation */}
                </div>
                <div className="sectionMobile">
                  {/* Mobile Navigation */}
                  <div className="MobileLoginItem">
                    <Placeholder name="mobile_login_container" rendering={props.rendering} />
                  </div>
                  <div className="MobileCartItem">
                    <Placeholder name="mobile_cart_container" rendering={props.rendering} />
                  </div>
                  <div className="mobile-header-navigation-wrapper">
                    <Placeholder name="mobile_navigation_container" rendering={props.rendering} />
                  </div>
                  {/* END Mobile Navigation */}
                </div>
              </Toolbar>
              {/* TODO: Causes Horizontal Scrollbar */}
              {/* <hr className={classes.navigationBorder} /> */}
            </AppBar>
          </div>
        </div>
      </nav>
    </div>
  );
}
